import React, { useEffect, useState } from "react";
import { Handshake, Percent } from "lucide-react";
import { api } from "@/lib/api";
import { money } from "@/components/admin/AssociatesPanel";
import { AssociateStatementButton } from "@/components/admin/AssociateStatementButton"; // lot 711 — mon relevé mensuel PDF

// Lot 710 — carte « Ma part d'associé » dans la Comptabilité d'un associé : sa part, ses gains potentiels (mois par mois),
// ce qui lui a déjà été versé et le solde. Se masque si le membre n'est pas associé.
const monthLabel = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("fr-FR", { month: "short", year: "numeric" });

export const MyAssociateShareCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/associates/me").then(({ data }) => setD(data)).catch(() => setD(false)); }, []);
  if (!d || !d.me) return null;
  const me = d.me;
  const cur = d.currency || "EUR";
  const tiles = [
    ["Ma part", `${Number(me.pct || 0).toLocaleString("fr-FR")} %`, "#92400E", "pct"],
    ["Gains potentiels", money(me.earned_total, cur), (me.earned_total || 0) < 0 ? "#B91C1C" : "var(--yalola-primary)", "earned"],
    ["Ce mois", money(me.earned_month, cur), (me.earned_month || 0) < 0 ? "#B91C1C" : "var(--yalola-text)", "month"],
    ["Déjà versé", money(me.paid_total, cur), "#6B7280", "paid"],
    ["Solde", money(me.balance, cur), (me.balance || 0) < 0 ? "#B91C1C" : "#1B7A3D", "balance"],
  ];
  return (
    <div className="yalola-card p-5 space-y-3" data-testid="my-associate-share">
      <div className="flex items-center gap-2">
        <div className="h-10 w-10 rounded-xl grid place-items-center" style={{ background: "var(--yalola-primary-soft)", color: "var(--yalola-primary)" }}><Handshake size={20} /></div>
        <div>
          <div className="font-bold font-display">Ma part d'associé</div>
          <div className="text-xs" style={{ color: "var(--yalola-text-muted)" }}>Part du revenu net de la plateforme depuis {monthLabel(me.since)} · revenu net cumulé {money(d.pool?.net_total, cur)}</div>
        </div>
        <span className="chip text-xs font-bold flex items-center gap-1 ml-auto" style={{ background: "#FEF3C7", color: "#92400E" }}><Percent size={11} /> {Number(me.pct || 0).toLocaleString("fr-FR")} %</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
        {tiles.map(([l, v, c, k]) => (
          <div key={k} className="rounded-xl p-3" style={{ background: "var(--yalola-surface-alt)" }}>
            <div className="text-[10px] uppercase font-bold tracking-wide" style={{ color: "var(--yalola-text-muted)" }}>{l}</div>
            <div className="font-extrabold mt-0.5" style={{ color: c }} data-testid={`my-share-${k}`}>{v}</div>
          </div>
        ))}
      </div>
      <div className="text-xs space-y-0.5" data-testid="my-share-months">
        {(me.months || []).slice().reverse().slice(0, 6).map((m) => (
          <div key={m.month} className="flex justify-between border-b py-0.5" style={{ borderColor: "var(--yalola-border)" }}>
            <span className="capitalize">{monthLabel(m.month)}</span><span style={{ color: "var(--yalola-text-muted)" }}>net {money(m.net, cur)} × {Number(m.pct).toLocaleString("fr-FR")} %</span><b>{money(m.share, cur)}</b>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <AssociateStatementButton associateId={me.id} since={me.since} testId="my-share-statement" />
        <p className="text-[11px]" style={{ color: "var(--yalola-text-muted)" }}>Gains potentiels : part du revenu net (revenus − frais stores/Stripe − TVA − dépenses − remboursements). Les versements sont enregistrés par le super admin.</p>
      </div>
    </div>
  );
};

export default MyAssociateShareCard;
